/**
 * O que a escaramuça precisa saber de uma sala online — e a conta do desfecho.
 *
 * Hoje o desafio online é jogado em paralelo: cada jogador enfrenta a CPU no
 * próprio navegador, no mesmo mapa e com a MESMA semente da sala, e o primeiro
 * desfecho registrado fecha a sala. O servidor autoritativo, que faria os dois
 * lados jogarem a mesma partida, ainda não existe (ver docs/PLANO.md, Etapa 8).
 */

export interface OnlineLobbyRef {
  readonly id: number;
  readonly host: { readonly id: number };
  readonly guest: { readonly id: number } | null;
  /** Quem está olhando é o anfitrião? A API diz isto para cada visitante. */
  readonly isHost?: boolean;
  /** A semente da sala — só sai da API para quem está nela. */
  readonly seed?: number;
}

/**
 * Quem venceu a sala, dado o desfecho da partida DE QUEM ESTÁ JOGANDO.
 *
 * `vitoria` é a vitória do lado deste navegador. A conta antiga tomava
 * vitória como vitória do anfitrião: o convidado que vencia registrava o
 * anfitrião como vencedor, e o que perdia registrava a si mesmo.
 *
 * `null` quando não há dois jogadores — não há de quem ter vencido.
 */
export function onlineWinner(lobby: OnlineLobbyRef, won: boolean): number | null {
  const guestId = lobby.guest?.id;
  if (guestId === undefined) return null;

  const me = lobby.isHost === false ? guestId : lobby.host.id;
  const opponent = me === lobby.host.id ? guestId : lobby.host.id;
  return won ? me : opponent;
}

/** A semente com que a partida abre: a da sala, quando houver uma. */
export function matchSeed(lobby: OnlineLobbyRef | null | undefined, random: () => number): number {
  const seed = lobby?.seed;
  return typeof seed === 'number' && Number.isInteger(seed) && seed > 0
    ? seed
    : Math.floor(random() * 0x7fffffff);
}
